
/* SEARCH FILTERS */
import {IRsSearchFilters} from "./models";
import * as yup from "yup";


const VALID_DOCUMENT_TYPES = ["Contract document", "Insurance document"];

export const SEARCH_FILTERS_FORM_INITIAL_VALUES: IRsSearchFilters = {
    nameCode: {code: '', description: ''},
    identificationCode: '',
    category: [],
    currentStatus: '',
    currentAttribute: '',
    region: '',
    province: '',
    city: '',
    chargingStationStatus: '',
    chargingStationIdentificationCode: '',
    certificationProtocolIdentificationCode: '',
    tenants: null,
    dealers: null,
}

// Validation Schema
export const SEARCH_FILTERS_FORM_VALIDATION_SCHEMA = yup.object().shape({
    nameCode: yup.string()
        .nullable(),
    identificationCode: yup.string()
        .nullable(),
    sapId: yup.string()
        .nullable(),
    rsCategory: yup.string()
        .nullable(),
    currentStatus: yup.string()
        .nullable(),
    currentAttribute: yup.string()
        .nullable(),
    region: yup.string()
        .nullable(),
    province: yup.string()
        .nullable(),
    city: yup.string()
        .nullable(),
    chargingStationIdentificationCode: yup.string()
        .nullable(),
    chargingStationStatus: yup.string()
        .nullable(),
    chargingColumnId: yup.string()
        .nullable(),
    certificationProtocolIdentifyingCode: yup.string()
        .nullable()
});

export const RS_DOCUMENTS_FORM_VALIDATION_SCHEMA = yup.object().shape({
    documents: yup.array().of(yup.object().shape({
        file: yup.string().required("Required"),
        title: yup.string().nullable().required("Required"),
        note: yup.string().ensure().when('title', {
            is: 'Other',
            then: yup.string().required("Required field")
          }),
        validityStartDate: yup.date().nullable().when('title', {
            is: (title: string) => VALID_DOCUMENT_TYPES.includes(title),
            then: (schema) => schema.required("Required field"),
        }),
        validityEndDate: yup.date().nullable().min(
            yup.ref("validityStartDate"),
            "End date has to be more or equal than start date"
         ).when('title', {
            is: (title: string) => VALID_DOCUMENT_TYPES.includes(title),
            then: (schema) => schema.required("Required field"),
        }),
        validityAnnualPremiumEndDate: yup.date().nullable().when('title', {
            is: "Insurance document",
            then: yup.date().required("Required field")
          })
    }))
});

export const RS_CATEGORY = ['Repair shop'];
